import Footer from "./components/Footer/Footer";
import Nav from "./components/nav/Nav";
import Index from "./page/Index";
import Nfts from "./page/Nfts";
import Details from "./page/Details";
import Wallet from "./page/Wallet";
import Transfer from "./page/Transfer";
import Withdraw from "./page/Withdraw";
import Comic from "./page/Comic";
import Marketplace from "./page/Marketplace";
import { Routes, Route, Link } from "react-router-dom";

function App() {
  return (
    <div>
      <Nav />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="monkedoos" element={<Nfts />} />
        <Route path="details/:id" element={<Details />} />
        <Route path="wallet" element={<Wallet />} />
        <Route path="withdraw" element={<Withdraw />} />
        <Route path="comic" element={<Comic />} />
        <Route path="transfer/:id" element={<Transfer />} />
        <Route path="marketplace" element={<Marketplace />} />
      </Routes>
      {/* <Header />
      <Project />
      <About />
      <Minter />
      <Roadmap />
      <Faqs />
      */}
      <Footer />
    </div>
  );
}

export default App;
